import { useEffect } from "react";
import ReactGA from "react-ga4";

function useGlobalTracking() {
  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target;

      if (target.tagName === "BUTTON") {
        const text = target.innerText;

        ReactGA.event({
          category: "Auto",
          action: "Button Click",
          label: text || "Unknown Button"
        });
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
}

export default useGlobalTracking;